// ConfirmModal.js — Dialog konfirmasi yang bisa dipakai di mana saja
// Letakkan di: src/component/khas/ConfirmModal.js
//
// Props:
//   state   — objek { title, message (boleh HTML), yes, danger, onYes } | null
//   onClose — callback untuk tutup modal
import React from 'react'

function ConfirmModal({ state, onClose }) {
  if (!state) return null

  return (
    <div
      className="khas-modal show"
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
    >
      <div className="khas-modal-box" style={{ maxWidth: 440 }}>
        <div className="khas-modal-header">
          <h3>{state.title || 'Konfirmasi'}</h3>
          <button className="khas-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="khas-modal-body">
          <p
            dangerouslySetInnerHTML={{ __html: state.message }}
            style={{ marginBottom: 20, fontSize: 14.5 }}
          />
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button className="khas-btn khas-btn-outline" onClick={onClose}>
              Batal
            </button>
            <button
              className={`khas-btn ${state.danger ? 'khas-btn-danger' : 'khas-btn-primary'}`}
              onClick={() => { state.onYes(); onClose() }}
            >
              {state.yes || 'Ya, lanjutkan'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal